// 校验手机号
const checkPhoneNumber = (phoneNum) => {
  return /^1(3|4|5|6|7|8|9)\d{9}$/.test(phoneNum)
}
// 校验密码 6-10位 包含区分大小写字母及数字
const checkPassword = (passWord) => {
  return /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{6,12}/.test(passWord)
  // 不区分大小写的正则/(?=.*[0-9])(?=.*[a-zA-Z]).{6,12}/
  // 其他正则
  // 由数字、小写字符和大写字母组成，但必须至少包括 2 种字符。
  // var regex = /((?=.*[0-9])(?=.*[a-z])|(?=.*[0-9])(?=.*[A-Z])|(?=.*[a-z])(?=.*[AZ]))^[0-9A-Za-z]{6,12}$/;
}

// 处理文件下载流
const blobLoad = (content, fileName, fileType) => { // content是返回的数据，fileName是文件名字
  const blob = new Blob([content], {
    type: fileType ? 'application/vnd.ms-excel' : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'
  }) // 创建一个类文件Blob对象
  const url = window.URL.createObjectURL(blob) // 生成一个File对象或Blob对象
  if ('download' in document.createElement('a')) {
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } else {
    navigator.msSaveBlob(blob, fileName)
  }
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

// 时间转换
const formatTime = (date, dot, type) => {
  if (!date) {
    return ''
  }
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  const newDot = dot || '/'
  if (!type) {
    return [year, month, day].map(formatNumber).join(newDot) + ' ' + [hour, minute, second].map(formatNumber).join(':')
  } else {
    return [year, month, day].map(formatNumber).join(newDot)
  }
}

export default {
  checkPhoneNumber,
  checkPassword,
  blobLoad,
  formatTime
}



// WEBPACK FOOTER //
// ./src/utils/utils.js